/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_PriorityInputs */

const en_pricing_compare_priority = /** @type {(inputs: Pricing_Compare_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const de_pricing_compare_priority = /** @type {(inputs: Pricing_Compare_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorität`)
};

const fr_pricing_compare_priority = /** @type {(inputs: Pricing_Compare_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioritaire`)
};

const es_pricing_compare_priority = /** @type {(inputs: Pricing_Compare_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioritario`)
};

const it_pricing_compare_priority = /** @type {(inputs: Pricing_Compare_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioritario`)
};

const nl_pricing_compare_priority = /** @type {(inputs: Pricing_Compare_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioriteit`)
};

const pl_pricing_compare_priority = /** @type {(inputs: Pricing_Compare_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorytetowy`)
};

const fi_pricing_compare_priority = /** @type {(inputs: Pricing_Compare_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etusija`)
};

const da_pricing_compare_priority = /** @type {(inputs: Pricing_Compare_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioritet`)
};

const sv_pricing_compare_priority = /** @type {(inputs: Pricing_Compare_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioritet`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Pricing_Compare_PriorityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_priority = /** @type {((inputs?: Pricing_Compare_PriorityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_PriorityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_priority(inputs)
	if (locale === "fr") return fr_pricing_compare_priority(inputs)
	if (locale === "es") return es_pricing_compare_priority(inputs)
	if (locale === "it") return it_pricing_compare_priority(inputs)
	if (locale === "nl") return nl_pricing_compare_priority(inputs)
	if (locale === "pl") return pl_pricing_compare_priority(inputs)
	if (locale === "fi") return fi_pricing_compare_priority(inputs)
	if (locale === "da") return da_pricing_compare_priority(inputs)
	if (locale === "sv") return sv_pricing_compare_priority(inputs)
	return en_pricing_compare_priority(inputs)
});